import StyledTypo from '@tmh-website/styles/typo';
import { ButtonThemeColor, buttonThemes } from '@tmh-website/ui/Button';
import styled, { css } from 'styled-components';

export interface StyledIconButtonProps {
  $themeColor: ButtonThemeColor;
  $isLoading?: boolean;
  $isSmall?: boolean;
  $isTransparent?: boolean;
  $phosphorPadding?: boolean;
  ref?: any;
}

export const Container = styled.button<StyledIconButtonProps>`
  ${StyledTypo.uiTextCss};
  position: relative;
  z-index: 1;
  display: flex;
  flex-shrink: 0;
  gap: ${props => props.theme.gap.xSmall};
  align-items: center;
  justify-content: center;
  padding: ${props => (!!props.$phosphorPadding ? 6 : 2)}px;
  overflow: hidden;
  line-height: 1.1;
  color: ${props => props.theme.color[buttonThemes[props.$themeColor].text]};
  text-align: center;
  cursor: pointer;
  background-color: ${props =>
    props.$isTransparent ? 'transparent' : props.theme.color[buttonThemes[props.$themeColor].background.normal]};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  transition: ${props => props.theme.transitionTiming};
  ${props =>
    props.$isSmall &&
    css`
      @media (${props => props.theme.breakpoint.lg.up}) {
        padding: ${!!props.$phosphorPadding ? 8 : 0}px;
        margin: 2px;
      }
    `}

  > * {
    flex-shrink: 0;
  }

  &:hover {
    text-decoration: none;
    background-color: ${props => props.theme.color[buttonThemes[props.$themeColor].background.hover]};
  }

  &:active {
    background-color: ${props => props.theme.color[buttonThemes[props.$themeColor].background.active]};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.2;

    &:active {
      pointer-events: none;
    }
  }

  ${props =>
    props.$isLoading &&
    css`
      background-color: ${props.theme.color[buttonThemes[props.$themeColor].background.hover]};
      box-shadow: none;
      cursor: wait !important;
      color: transparent !important;

      &:active {
        pointer-events: none;
      }
    `}
`;
